// 今はdocument下だが移したいものがある.明示的に参照を書く.
// TODO: 見直せるタイミングで階層変更したい.
export { MuscularStrengthValueKinds as ManualMuscleTestPresentMethods } from "../../../../../domain/document";
